import {
  CHECK_AUTH_STATUS_SUCCEEDED,
  VERIFY_AUTH_CODE_SUCCEEDED,
  LOG_OUT_SUCCEEDED,
} from './actionTypes'

const authenticated = (state = false, action) => {
  switch (action.type) {
    case CHECK_AUTH_STATUS_SUCCEEDED:
    case VERIFY_AUTH_CODE_SUCCEEDED:
      return action.authenticated

    case LOG_OUT_SUCCEEDED:
      return false

    default:
      return state
  }
}

export const isAuthenticated = (state) => state

export default authenticated
